export default __webpack_public_path__ + "static/media/icon_hesitant.90cefd7b.svg";